// @flow
export const SCROLL_ANCHOR = 'scrollAnchor';
export const MAIN = 'main';
export const ADULTS = 'adults';
export const KIDS = 'kids';
export const YEAR_OF_MAJORITY = 18;
export const MAX_AGE = 100;
//CGUs IDs
export const CNIL_LEGAL_MESSAGE_ID = 'CNIL';
export const GENERAL_PERSONAL_INFORMATION = 'GENERAL_PERSONAL_INFORMATION';
export const UNIQUE_IDENTIFICATION_INFORMATION = 'UNIQUE_IDENTIFICATION_INFORMATION';
export const THIRD_PARTY_PROVISION = 'THIRD_PARTY_PROVISION';
export const OVERSEAS_PROVISION = 'OVERSEAS_PROVISION';
export const OVERSEAS_PROVISION_INSURANCE = 'OVERSEAS_PROVISION_INSURANCE';
